import { App } from 'antd';

let notification: ReturnType<typeof App.useApp>['notification'];

export function useInitNotification() {
    notification = App.useApp().notification;
}

export { notification };
